import React from 'react';
import { useToast, ToastItem } from '../contexts/ToastContext';

const typeStyles: Record<ToastItem['type'], string> = {
  success: 'bg-emerald-50 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800',
  error: 'bg-red-50 dark:bg-red-900/40 text-red-700 dark:text-red-300 border-red-200 dark:border-red-800',
  info: 'bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-200 dark:border-gray-800',
};

const typeIcons: Record<ToastItem['type'], string> = {
  success: '✓',
  error: '✕',
  info: 'i',
};

/**
 * Global toast container. Render once at app root (inside ToastProvider).
 * Uses fixed positioning at top-right with auto-dismiss after 3.5s.
 */
const ToastContainer: React.FC = () => {
  const { toasts, dismissToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-20 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-[100] flex flex-col gap-2 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role="status"
          className={`px-4 py-3 rounded-xl text-sm font-medium shadow-lg backdrop-blur-sm border pointer-events-auto flex items-start gap-3 animate-[fadeIn_200ms_ease-out] ${typeStyles[toast.type]}`}
        >
          <span className="w-5 h-5 rounded-full bg-current/10 flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">
            {typeIcons[toast.type]}
          </span>
          <span className="flex-1">{toast.message}</span>
          <button
            type="button"
            onClick={() => dismissToast(toast.id)}
            className="text-current/70 hover:text-current transition-colors shrink-0"
            aria-label="Dismiss"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
